import "./column-components.cbe585ce.js";
import "./column-components.f3ae60c5.js";
import "./column-components.298cc9f3.js";
import "./column-components.e595a3de.js";
import {useContext as $cGGN9$useContext, useState as $cGGN9$useState} from "react";
import $cGGN9$macrostrathyper from "@macrostrat/hyper";
import {Button as $cGGN9$Button, Intent as $cGGN9$Intent} from "@blueprintjs/core";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $e130c0352c59745c$exports = {};

$parcel$export($e130c0352c59745c$exports, "LithologyPicker", () => $e130c0352c59745c$export$a685fa91ddfa1b86);
$parcel$export($e130c0352c59745c$exports, "LithologySymbolPicker", () => $e130c0352c59745c$export$e882965600ccf2f4);



var $38gjf = parcelRequire("38gjf");


var $bohgQ = parcelRequire("bohgQ");

var $aVUB5 = parcelRequire("aVUB5");

var $cJZBk = parcelRequire("cJZBk");
const $e130c0352c59745c$var$h = (0, $cGGN9$macrostrathyper).styled((0, (/*@__PURE__*/$parcel$interopDefault($cJZBk))));
const $e130c0352c59745c$var$LithologySwatch = function({ symbolID: symbolID, style: style, ...rest }) {
    const { resolvePattern: resolvePattern } = (0, $cGGN9$useContext)((0, $bohgQ.GeologicPatternContext));
    const src = resolvePattern(symbolID);
    if (style == null) style = {};
    style.backgroundImage = `url(\"${src}\")`;
    return $e130c0352c59745c$var$h("div.lithology-swatch", {
        style: style,
        ...rest
    });
};
const $e130c0352c59745c$var$LithologyItem = function(props) {
    const { symbol: symbol, lithology: lithology } = props;
    return $e130c0352c59745c$var$h("span.facies-picker-row", [
        $e130c0352c59745c$var$h($e130c0352c59745c$var$LithologySwatch, {
            symbolID: symbol
        }),
        $e130c0352c59745c$var$h("span.facies-picker-name", lithology)
    ]);
};
const $e130c0352c59745c$export$a685fa91ddfa1b86 = (props)=>{
    const { interval: interval, onChange: onChange } = props;
    const { lithologies: lithologies } = (0, $cGGN9$useContext)((0, $aVUB5.LithologyContext));
    console.log("lithologies", lithologies, interval);
    let options = [];
    for (let item of lithologies){
        const { id: id, pattern: pattern } = item;
        const symbol = (0, $bohgQ.symbolIndex)[pattern];
        // if (symbol == null) {
        //   continue;
        // }
        options.push({
            value: id,
            label: $e130c0352c59745c$var$h($e130c0352c59745c$var$LithologyItem, {
                lithology: id,
                symbol: symbol
            })
        });
    }
    let value = options.find((d)=>d.value === interval.lithology_id);
    return $e130c0352c59745c$var$h((0, $38gjf.RaisedSelect), {
        id: "lithology-select",
        options: options,
        value: value,
        isClearable: true,
        onChange (res) {
            const f = res != null ? res.value : null;
            return onChange(f);
        }
    });
};
const $e130c0352c59745c$var$SymbolPickerInner = function(props) {
    let symbol;
    const { interval: interval, onClose: onClose, style: style } = props;
    let isUserSet = false;
    let text = "No pattern set";
    if (interval.pattern != null) {
        symbol = interval.pattern;
        isUserSet = true;
        text = `Symbol ${symbol}`;
    }
    if (interval.lithology != null) {
        symbol = (0, $bohgQ.symbolIndex)[interval.lithology];
        text = "Default for lithology";
    }
    return $e130c0352c59745c$var$h("div.lithology-symbol-picker-inner", {
        style: style
    }, [
        $e130c0352c59745c$var$h.if(symbol != null)($e130c0352c59745c$var$LithologySwatch, {
            symbolID: symbol
        }),
        $e130c0352c59745c$var$h("div.picker-label.text", text),
        $e130c0352c59745c$var$h.if(onClose != null)((0, $cGGN9$Button), {
            small: true,
            icon: "cross",
            intent: (0, $cGGN9$Intent).DANGER,
            minimal: true,
            onClick: onClose
        }, "Clear override")
    ]);
};
const $e130c0352c59745c$export$e882965600ccf2f4 = function(props) {
    const { interval: interval, updatePattern: updatePattern } = props;
    const [isExpanded, setIsExpanded] = (0, $cGGN9$useState)(false);
    const className = isExpanded ? "expanded" : "hidden";
    return $e130c0352c59745c$var$h("div.lithology-symbol-picker", {
        className: className
    }, [
        $e130c0352c59745c$var$h((0, $cGGN9$Button), {
            className: "expand-button",
            onClick () {
                setIsExpanded(true);
            },
            minimal: true,
            small: true,
            intent: (0, $cGGN9$Intent).WARNING
        }, "Override lithology pattern"),
        $e130c0352c59745c$var$h($e130c0352c59745c$var$SymbolPickerInner, {
            interval: interval,
            onClose: ()=>setIsExpanded(false),
            updatePattern: updatePattern
        })
    ]);
};


export {$e130c0352c59745c$export$a685fa91ddfa1b86 as LithologyPicker, $e130c0352c59745c$export$e882965600ccf2f4 as LithologySymbolPicker};
//# sourceMappingURL=column-components.f7928429.js.map
